import { Flex } from '@aloft/toolkit-sui';
import { Box } from '@aloft/toolkit-sui/chakra';

import { TwoLineCell } from '../../../Grid/TwoLineCell.tsx';
import { CompSelectionProperty } from '../../types.ts';
import { RankPinIcon } from './RankPinIcon.tsx';
import { SubjectPinIcon } from './SubjectPinIcon.tsx';
import { WarningTooltipIcon } from './WarningTooltipIcon.tsx';
import { getPinColor } from './getPinColor.ts';

export function addressColumn(
  property: CompSelectionProperty,
  { showPinAndWarnings = false }: { showPinAndWarnings?: boolean } = {},
) {
  const { address, id, similarityRank, reo, shortSale } = property;
  const { AddressLineText, CityName, StateCode, PostalCode } = address || {};

  return (
    <Flex justifyContent="space-between" alignItems="center" width="100%" gap="8px">
      {showPinAndWarnings && (
        <Flex height="100%" alignItems="center" justifyContent="center" flexShrink={0}>
          {id === 'subject' ? (
            <SubjectPinIcon />
          ) : (
            <RankPinIcon color={getPinColor(property)} rank={similarityRank} />
          )}
        </Flex>
      )}
      <Box paddingRight={2} flexGrow={1} minWidth={0}>
        <TwoLineCell
          line1={AddressLineText ?? ''}
          line2={`${CityName}, ${StateCode} ${PostalCode}`}
        />
      </Box>
      {showPinAndWarnings && (reo || shortSale) && (
        <Flex alignItems="center" gap="4px" flexShrink={0}>
          {reo && <WarningTooltipIcon label="This is a REO transaction" />}
          {shortSale && <WarningTooltipIcon label="This is a short sale transaction" />}
        </Flex>
      )}
    </Flex>
  );
}
